import React from 'react';
import PropTypes from 'prop-types';

import {dispatch, connect} from 'utils/state_manager';

import {Stack, Paper, Typography} from 'views/components';

import {Translate} from 'views/module';

import {
  EmailBox,
  MagicLinkSentBox,
  MagicLinkReceiveBox,
  ErrorBox,
  ResetPasswordBox,
  ForgotPasswordBox,
  OtpBox,
} from './auth_boxes';

import {useSearchParams} from 'react-router-dom';


const Authentication = (props) => {
  const token = props.token;

  const [params] = useSearchParams();
  const registrationEmail = params.get('email');

  const [challengeName, setChallengeName] = React.useState('START');
  const [userData, setUserData] = React.useState(null);
  const [forgotPasswordEmail, setForgotPasswordEmail] = React.useState('');
  const [otpEmail, setOtpEmail] = React.useState('');

  const onResetPassword = (newUserData) => {
    setUserData(newUserData);
    setChallengeName('RESET_PASSWORD');
  };

  const onForgotPassword = (email) => {
    setForgotPasswordEmail(email);
    setChallengeName('FORGOT_PASSWORD');
  };

  const onOtpLogin = (email) => {
    setOtpEmail(email);
  };

  React.useEffect(() => {
    if (token) {
      setChallengeName('MAGIC_LINK_RECEIVED');
    } else if (registrationEmail) {
      setChallengeName('OTP');
    }
  }, [token, registrationEmail]);

  const getAuthBox = () => {
    if (challengeName === 'MAGIC_LINK') {
      return <MagicLinkSentBox />;
    } else if (challengeName === 'MAGIC_LINK_RECEIVED') {
      return <MagicLinkReceiveBox token={token} />;
    } else if (challengeName === 'RESET_PASSWORD') {
      return <ResetPasswordBox userData={userData} />;
    } else if (challengeName === 'FORGOT_PASSWORD') {
      return <ForgotPasswordBox email={forgotPasswordEmail} setChallengeName={setChallengeName} />;
    } else if (challengeName === 'OTP') {
      return <OtpBox email={registrationEmail || otpEmail} setChallengeName={setChallengeName} />;
    } else if (challengeName === 'ERROR') {
      return <ErrorBox setChallengeName={setChallengeName} />;
    } else {
      return <EmailBox
        challengeName={challengeName}
        setChallengeName={setChallengeName}
        onResetPassword={onResetPassword}
        onForgotPassword={onForgotPassword}
        onOtpLogin={onOtpLogin}
      />;
    }
  };


  return (
    <Stack
      alignItems='center'
      height='100vh'
      sx={{
        justifyContent: {
          xs: 'start',
          sm: 'center',
        },
        bgcolor: 'background.default',
      }}
      gap={2}
    >
      <Stack
        marginInline={4}
        marginBlockStart={4}
        alignItems='center'
      >
        <Typography
          variant='h4'
          fontWeight='bold'
          color='primary.main'
          textAlign='center'
          marginBlockEnd={4}
        >
          <Translate expression='auth.WelcomeScreen.BrandName' />
        </Typography>
      </Stack>
      <Paper
        elevation={0}
        sx={{
          width: {
            xs: '80%',
            sm: 400,
            md: 576,
          },
          padding: {xs: 2, sm: 4},
          borderRadius: 3,
        }}
      >
        {getAuthBox()}
      </Paper>
    </Stack>
  );
};

Authentication.propTypes = {
  token: PropTypes.string,
};

const mapStateToProps = (state) => ({
});

export default connect(mapStateToProps, dispatch)(React.memo(Authentication));
